import { render } from "./card.vue?vue&type=template&id=619e653a&scoped=true"
const script = {}

import "./card.vue?vue&type=style&index=0&id=619e653a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-619e653a"

export default script